import React from 'react';
import { useNavigate } from 'react-router-dom';

const APIS = [
  {
    id: 'google-maps',
    nome: 'Google Maps Places',
    descricao: 'Localiza empresas por segmento e região para prospecção de leads.',
    icone: '📍',
    cor: '#4285F4',
    corBg: '#e8f0fe',
    ativo: true,
    path: '/apis/google-maps',
    recursos: [
      'Busca por segmento e cidade/região',
      'Retorna nome, endereço, telefone, site e avaliação',
      'Resultados prontos para análise da equipe',
    ],
  },
  {
    id: 'whatsapp-business',
    nome: 'WhatsApp Business API',
    descricao: 'Integração oficial com a API do WhatsApp para envio em escala.',
    icone: '💬',
    cor: '#25D366',
    corBg: '#e8fdf0',
    ativo: false,
    path: null,
    recursos: ['Em breve'],
  },
  {
    id: 'rd-station',
    nome: 'RD Station CRM',
    descricao: 'Sincronização de leads e oportunidades com o RD Station.',
    icone: '📊',
    cor: '#00A1E4',
    corBg: '#e6f7fd',
    ativo: false,
    path: null,
    recursos: ['Em breve'],
  },
  {
    id: 'cnpj',
    nome: 'Receita Federal — CNPJ',
    descricao: 'Consulta dados de empresas pelo CNPJ diretamente na Receita Federal.',
    icone: '🏛️',
    cor: '#6366f1',
    corBg: '#f0f0ff',
    ativo: false,
    path: null,
    recursos: ['Em breve'],
  },
];

export default function Apis() {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 24, maxWidth: 960, margin: '0 auto' }}>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ margin: 0, fontSize: 22, color: '#0a1628', fontWeight: 800 }}>🔌 Integrações & APIs</h1>
        <p style={{ margin: '6px 0 0', color: '#6b7280', fontSize: 14 }}>
          Central de integrações com serviços externos
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 20 }}>
        {APIS.map(api => (
          <div
            key={api.id}
            style={{
              background: '#fff',
              border: `1px solid ${api.ativo ? '#e5e7eb' : '#f3f4f6'}`,
              borderRadius: 16,
              padding: 24,
              boxShadow: api.ativo ? '0 2px 12px rgba(0,0,0,0.07)' : 'none',
              opacity: api.ativo ? 1 : 0.6,
              display: 'flex',
              flexDirection: 'column',
              gap: 12,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{
                width: 48, height: 48, borderRadius: 14,
                background: api.corBg,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 22,
              }}>
                {api.icone}
              </div>
              <span style={{
                fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 20,
                background: api.ativo ? '#f0fdf4' : '#f3f4f6',
                color: api.ativo ? '#16a34a' : '#9ca3af',
                border: `1px solid ${api.ativo ? '#bbf7d0' : '#e5e7eb'}`,
              }}>
                {api.ativo ? '● Disponível' : '○ Em breve'}
              </span>
            </div>

            <div>
              <div style={{ fontWeight: 800, fontSize: 16, color: '#0a1628', marginBottom: 4 }}>{api.nome}</div>
              <div style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.5 }}>{api.descricao}</div>
            </div>

            <ul style={{ margin: 0, padding: '0 0 0 16px', display: 'flex', flexDirection: 'column', gap: 4 }}>
              {api.recursos.map((r, i) => (
                <li key={i} style={{ fontSize: 12, color: '#6b7280' }}>{r}</li>
              ))}
            </ul>

            <button
              onClick={() => api.ativo && api.path && navigate(api.path)}
              disabled={!api.ativo}
              style={{
                marginTop: 4,
                padding: '10px 0',
                borderRadius: 10,
                border: 'none',
                cursor: api.ativo ? 'pointer' : 'default',
                background: api.ativo ? `linear-gradient(135deg, ${api.cor}, ${api.cor}cc)` : '#f3f4f6',
                color: api.ativo ? '#fff' : '#9ca3af',
                fontWeight: 700,
                fontSize: 14,
                transition: 'opacity 0.15s',
              }}
              onMouseEnter={e => { if (api.ativo) e.currentTarget.style.opacity = '0.85'; }}
              onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}
            >
              {api.ativo ? 'Acessar' : 'Em breve'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
